// extracted by mini-css-extract-plugin
export default {"container":"ContainerUI_container__l6r4u"};